import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, Text, Box, Anchor } from 'grommet';
import { FormClose } from 'grommet-icons';

import { ErrorForm } from '../../../../components';
import { TitleDetail } from '../../../../components/detail';

import { searchVoters } from '../../actions/form-search';
import { remove, toggleFormDeleteLayer } from '../../actions/form-delete';

import visibleWidth from '../../../../constants/layer-width';

class FormDelete extends Component {
  callbackPostSuccess = () => {
    const {
      searchVoters,
      toggleFormDeleteLayer,
    } = this.props;

    searchVoters();
    toggleFormDeleteLayer();
  };

  handlePost = formParams => {
    const { remove } = this.props;
    remove({
      formParams,
      callbackSuccess: this.callbackPostSuccess
    });
  };

  render() {
    const {
      id,
      reference,
      name,
      telephone,
      email,

      toggleLayer,
      loadingPostForm,
      postDataError,
      toggleFormDeleteLayer,
    } = this.props;


    if(toggleLayer && toggleLayer === 'delete') {
      return (
        <ResponsiveContext.Consumer>
          {size => (
            <Layer
              responsive={false}
              full='vertical'
              position='left'
              onClickOutside={toggleFormDeleteLayer}
              onEsc={toggleFormDeleteLayer}
            >
              <Box
                fill='vertical'
                width={visibleWidth[size]}
                pad={{ top: 'large', bottom: 'xsmall' }}
                overflow='auto'
                flex
              >
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                  margin={{ horizontal: 'large' }}
                >
                  <TitleDetail value='Excluir eleitor' />

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={toggleFormDeleteLayer}
                  />
                </Box>


                <Box flex overflow='auto'>
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Text color='dark-2' size='small'>
                      Ao excluir o eleitor, todas as informações relacionadas (comentários, notificações, lembretes) serão perdidas.
                      Após a confirmação, a exclusão será permanente e não poderá ser desfeita.
                    </Text>
                  </Box>


                  <Box
                    flex={{ shrink: 0 }}
                    border={ { color: 'light-5', size: 'xsmall' } }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    pad={{ horizontal: 'medium', vertical: 'medium' }}
                    round='small'
                    gap='medium'
                  >
                    <Box
                      direction='row'
                      align='baseline'
                      justify='between'
                    >
                      <Text size='small' color='dark-2'>Referência</Text>
                      <Text size='medium' color='dark-4'>{reference}</Text>
                    </Box>

                    <Box
                      direction='row'
                      align='baseline'
                      justify='between'
                    >
                      <Text size='small' color='dark-2'>Nome</Text>
                      <Text size='medium' color='dark-4'>{name}</Text>
                    </Box>

                    {telephone && (
                      <Box
                        direction='row'
                        align='baseline'
                        justify='between'
                      >
                        <Text size='small' color='dark-2'>Telefone</Text>
                        <Text size='medium' color='dark-4'>{telephone}</Text>
                      </Box>
                    )}

                    {email && (
                      <Box
                        direction='row'
                        align='baseline'
                        justify='between'
                      >
                        <Text size='small' color='dark-2'>E-mail</Text>
                        <Text size='medium' color='dark-4'>{email}</Text>
                      </Box>
                    )}

                    <Box
                      flex={{ shrink: 0 }}
                    >
                      <ErrorForm errorsList={postDataError.errors} />
                    </Box>
                  </Box>
                </Box>


                {/* botoes acao */}
                <Box
                  direction='row'
                  pad={{ vertical: 'medium' }}
                  justify='center'
                  align='center'
                  gap='small'
                >
                  <Box width='xsmall'>
                    <Anchor
                      color='dark-3'
                      label='Cancelar'
                      disabled={ loadingPostForm }
                      onClick={toggleFormDeleteLayer}
                    />
                  </Box>

                  <Box width='small'>
                    <Button
                      color='status-error'
                      primary
                      label={ !loadingPostForm ? 'SIM, Excluir' : 'Excluindo...' }
                      disabled={ loadingPostForm }
                      onClick={() =>
                        this.handlePost({
                          id
                        })
                      }
                    />
                  </Box>
                </Box>

              </Box>
            </Layer>
          )}
        </ResponsiveContext.Consumer>
      )
    }

    return null;
  }
}

const mapStateToProps = ({
  votersReducer: { remove },
  layerReducer,
 }) => ({
  id: remove.id,
  reference: remove.reference,
  name: remove.name,
  telephone: remove.telephone,
  email: remove.email,

  loadingPostForm: remove.loadingPostForm,
  postDataError: remove.postDataError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    remove,
    searchVoters,
    toggleFormDeleteLayer,
  }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(FormDelete);
